import React from 'react';
import styled from '@benzinga/themetron';

import { Carousel } from '@benzinga/ui';
import { Button, Text } from '@benzinga/core-ui';
import { EntityCard } from '@benzinga/entity-ui';

import MoneyPostTemplate from './MoneyPostTemplate';
import { MoneyTemplateProps } from '../../entities';

const getLargeImage = images => {
  const results = images?.filter(image => {
    return image.size === 'large';
  });
  if (results[0]) {
    return results[0];
  }
  return images ? images.pop() : null;
};

const EntitiesHeader = ({ post }) => {
  const image = getLargeImage(post.featured_article.image);
  const imageUrl = image?.url;
  return (
    <>
      {post.featured_article && (
        <div className="header">
          <img alt="" className="bg-image" src={imageUrl} />
          <div className="header-container">
            <a href={post.featured_article.url}>
              <div className="post-container">
                <Text className="post-title" lines={3}>
                  {post.featured_article.title}
                </Text>
                <Text className="post-subtitle" lines={2}>
                  {post.featured_article.teaser}
                </Text>
                <Button variant="primary">READ MORE</Button>
              </div>
            </a>
          </div>
        </div>
      )}
      {post.entities && (
        <Carousel
          className="entities-carousel-wrapper"
          component={entity => <EntityCard entity={entity} variant="nano" />}
          items={post.entities}
          options={{ focus: 0 }}
          showPagination={false}
        />
      )}
    </>
  );
};

export const EntitiesTemplate: React.FC<MoneyTemplateProps> = ({ post }) => {
  const layout = 'narrow';
  return (
    <EntitiesTemplateWrapper className={layout}>
      <MoneyPostTemplate layoutHeader={<EntitiesHeader post={post} />} post={post} />
    </EntitiesTemplateWrapper>
  );
};

export default EntitiesTemplate;

const EntitiesTemplateWrapper = styled.div`
  h2 {
    font-size: 2rem;
  }
  .header {
    background-color: #111;
    overflow: hidden;
    position: relative;
    .bg-image {
      opacity: 0.2;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
      min-height: 500px;
      object-fit: cover;
    }
    .header-container {
      margin: auto;
      height: 500px;
      position: relative;
      padding-bottom: 220px;
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .post-container {
        color: ${({ theme }) => theme.colorPalette.white};
        max-width: 700px;
        @media screen and (max-width: 800px) {
          padding: 1rem;
        }
        .post-title {
          font-size: 2.5rem;
          line-height: 3.2rem;
          @media screen and (max-width: 800px) {
            font-size: 1.6rem;
            line-height: 2.2rem;
          }
        }
        .post-subtitle {
          font-size: 0.9rem;
        }
        button.primary {
          margin-top: 0.5rem;
          color: white;
          border: solid 1px #3f83f8;
          background: #3f83f8;
        }
      }
    }
  }
  &.narrow {
    .header-container,
    .layout-container {
      max-width: 1100px;
    }
  }
  .entities-carousel-wrapper {
    margin-left: -2rem;
    margin-top: -180px;
    .entity-card {
      width: 220px;
      box-shadow: ${({ theme }) => theme.shadow.md};
    }
    @media screen and (max-width: 800px) {
      margin-left: 0;
    }
  }
  .layout-footer {
    .layout-container {
      max-width: 1100px;
    }
  }
  .money-page-main {
    display: block !important;
    position: relative;
    width: 100%;

    .money-post-wrapper {
      width: 100%;
      min-width: 100%;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &.section-title {
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
  }
`;
